import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import React from 'react'
import moment from 'moment'
import './PackageTimeline.scss'
import classNames from 'classnames'
import { IOrderResponse } from '../../../libraries/interfaces/tracker.interfaces'
import { isObjectEmpty } from '../../../libraries/utils'
import PackageInformationTable from './CarrierOrderTable'

import 'moment/locale/en-gb'
import 'moment/locale/pt'

const CarrierOrderTimeline = ({ orderResponse }: { orderResponse: IOrderResponse }) => {
  const carrierInfo = orderResponse.carrier
  return (
    <div>
      <div className="rounded-2 text-white px-2 d-flex py-custom-1 bg-warning">
        <div className="flex-grow-1">
          <h4 className="mb-0">{carrierInfo.fullName}</h4>
        </div>
        <div className="text-end">
          <a href={orderResponse.order.link} target="_blank" rel="noreferrer" className="text-white">
            <i className="fas fa-external-link-alt" />
          </a>
        </div>
      </div>

      {!isObjectEmpty(orderResponse.order.information) && (
        <div className="mt-1">
          <PackageInformationTable orderResponse={orderResponse} />
        </div>
      )}

      <ul className="timeline mt-2">
        {orderResponse.order.states.map((state, index) => (
          <li className="mb-3" key={index}>
            <div className={classNames('timeline-icon', index === 0 ? 'bg-primary' : null)} />
            <div className="timeline-content">
              <div className="timeline-time">
                {state.date && (
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id={index + ''}>{moment(state.date).format('DD/MM/YYYY - HH:mm')}</Tooltip>}
                  >
                    <p className="tracking-event-date mb-0 text-muted fw-lighter">{moment(state.date).fromNow()}</p>
                  </OverlayTrigger>
                )}
                {!state.date && <div />}
              </div>
              <p className={classNames('timeline-title', index === 0 ? 'text-primary' : null)}>{state.description}</p>
              <p className="text-muted mb-0">{state.area && <Area area={state.area} />}</p>
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}

const Area = ({ area }) => (
  <small>
    <strong>{area}</strong>
  </small>
)

export default React.memo(CarrierOrderTimeline)
